export const shop = {
  branches: [],
  annotations: [
    {
      key: 'orderer',
      label: '申請人資訊',
      value: '{{customer.DELIVERY_NAME}}',
      required: true,
      type: 'ORDERER',
      validation: null,
      prerequisities: null,
      placeholder: '',
      isSystem: true,
    },
    {
      key: 'payment',
      label: '付款方式',
      value: '{{customer.PAYMENT_KEY}}',
      required: true,
      type: 'OPTIONS',
      validation: null,
      prerequisities: null,
      placeholder: '',
      sources: [
        { key: 'FACE', label: '面交付款' },
        { key: 'CUSTOM', label: '後續報價' },
      ],
      isSystem: true,
    },
    {
      key: 'delivery',
      label: '配送方式',
      value: '{{customer.DELIVERY_KEY}}',
      required: true,
      type: 'OPTIONS',
      validation: null,
      prerequisities: null,
      placeholder: '',
      sources: [{ key: 'FACE', label: '面交' }],
      isSystem: true,
    },
    {
      key: 'coupon',
      label: '折扣碼',
      value: '{{customer.META.coupon}}',
      required: false,
      type: 'COUPON',
      validation: null,
      prerequisities: null,
      placeholder: '',
      isSystem: true,
    },
    {
      key: 'INPUT_d2c890f0-b9af-41f1-a6b6-6ec836813486',
      label: '備註',
      value: '{{customer.META.INPUT_d2c890f0-b9af-41f1-a6b6-6ec836813486}}',
      required: false,
      type: 'INPUT',
      validation: null,
      prerequisities: null,
      placeholder: '',
    },
  ],
  settings: {
    formica: {
      categoryInfos: [
        {
          id: 1319,
          title: '富美家®裝飾\\n美耐板^潔菌板:木紋',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-24feed82-d109-4fbc-bb90-6be7ee375eda',
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-1fbe59e9-8da9-4abb-a43c-7b80ddc76b92',
          ],
        },
        {
          id: 1318,
          title: '富美家®裝飾\\n美耐板^潔菌板:富美家®彩虹心®',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-1fbe59e9-8da9-4abb-a43c-7b80ddc76b92',
          ],
        },
        {
          id: 1315,
          title: '富美家®彩之芯:彩之戀',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-046f1149-c177-4e77-89a2-4347219131a1',
          ],
        },
        {
          id: 1310,
          title: '富美家®彩之芯:彩繪',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-d8b59359-2268-4c17-a1c7-4eff6043ddae',
          ],
        },
        {
          id: 1309,
          title: '富美家®裝飾\\n美耐板^潔菌板:彩繪',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-d8b59359-2268-4c17-a1c7-4eff6043ddae',
          ],
        },
        {
          id: 1303,
          title: '富美家®裝飾\\n美耐板^潔菌板:彩之戀',
          imgUrls: [
            'https://d5j80r6ig58b5.cloudfront.net/img/104/s00104-0377e01c-02e4-4bc5-a80e-6f53f8fe0a41',
          ],
        },
      ],
    },
  },
};

export const liff = {
  error: '',
  ready: true,
  init: async () => {},
  openWindow: async () => {},
  shareTargetPicker: async () => {},
  getProfile: async () => {
    // dev
    return {
      userId: 'Ube2f86e6ee310d0e6ca5c28f1f3247d8',
      displayName: '黃卷 Juan',
      statusMessage: 'じゅえん',
      pictureUrl:
        'https://profile.line-scdn.net/0hDLs-ZXAMG2NeVDCtltNlHC4EGAl9JUJxcDRVBWJWTAZgNloycTdVBmNSQVQxbVticjVSAG5QElRSR2wFQALnV1lkRlJiYls0ejRRgQ',
    };
  },
  getAccessToken: () =>
    'eyJhbGciOiJIUzI1NiJ9.R-nyj-9xpeEasM6zqRjVddnvBkN7rW0oBn_r9pTXAH8kaRUfcQe_wHeha1xdHEmfBI_nbGgzfFGE66elWcjGIS0UWZIU45IOziH5w1LeUHNXe6T3MIODzeivbgyqF86-RiFICDBDAfeTfq-vprggTomy2W40m_h1sQQbkfOHtwQ.8-DROnb50JFn6HzfcxQIv9qRvMum6_CqItTA2PlM7eo',
  isLoggedIn: () => true,
  isInClient: () => false,
};
